var L = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function V(i) {
  if (i.__esModule) return i;
  var f = i.default;
  if (typeof f == "function") {
    var c = function o() {
      return this instanceof o ? Reflect.construct(f, arguments, this.constructor) : f.apply(this, arguments);
    };
    c.prototype = f.prototype;
  } else c = {};
  return Object.defineProperty(c, "__esModule", { value: !0 }), Object.keys(i).forEach(function(o) {
    var E = Object.getOwnPropertyDescriptor(i, o);
    Object.defineProperty(c, o, E.get ? E : {
      enumerable: !0,
      get: function() {
        return i[o];
      }
    });
  }), c;
}
var X = { exports: {} };
function k(i) {
  throw new Error('Could not dynamically require "' + i + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var H = { exports: {} };
const j = {}, z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j
}, Symbol.toStringTag, { value: "Module" })), $ = /* @__PURE__ */ V(z);
var Y;
function G() {
  return Y || (Y = 1, function(i, f) {
    (function(c, o) {
      i.exports = o();
    })(L, function() {
      var c = c || function(o, E) {
        var l;
        if (typeof window < "u" && window.crypto && (l = window.crypto), typeof self < "u" && self.crypto && (l = self.crypto), typeof globalThis < "u" && globalThis.crypto && (l = globalThis.crypto), !l && typeof window < "u" && window.msCrypto && (l = window.msCrypto), !l && typeof L < "u" && L.crypto && (l = L.crypto), !l && typeof k == "function")
          try {
            l = $;
          } catch {
          }
        var w = function() {
          if (l) {
            if (typeof l.getRandomValues == "function")
              try {
                return l.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof l.randomBytes == "function")
              try {
                return l.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, R = Object.create || /* @__PURE__ */ function() {
          function t() {
          }
          return function(n) {
            var r;
            return t.prototype = n, r = new t(), t.prototype = null, r;
          };
        }(), S = {}, T = S.lib = {}, v = T.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(t) {
              var n = R(this);
              return t && n.mixIn(t), (!n.hasOwnProperty("init") || this.init === n.init) && (n.init = function() {
                n.$super.init.apply(this, arguments);
              }), n.init.prototype = n, n.$super = this, n;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var t = this.extend();
              return t.init.apply(t, arguments), t;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(t) {
              for (var n in t)
                t.hasOwnProperty(n) && (this[n] = t[n]);
              t.hasOwnProperty("toString") && (this.toString = t.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), d = T.WordArray = v.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(t, n) {
            t = this.words = t || [], n != E ? this.sigBytes = n : this.sigBytes = t.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(t) {
            return (t || A).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(t) {
            var n = this.words, r = t.words, s = this.sigBytes, _ = t.sigBytes;
            if (this.clamp(), s % 4)
              for (var u = 0; u < _; u++) {
                var p = r[u >>> 2] >>> 24 - u % 4 * 8 & 255;
                n[s + u >>> 2] |= p << 24 - (s + u) % 4 * 8;
              }
            else
              for (var I = 0; I < _; I += 4)
                n[s + I >>> 2] = r[I >>> 2];
            return this.sigBytes += _, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var t = this.words, n = this.sigBytes;
            t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = o.ceil(n / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var t = v.clone.call(this);
            return t.words = this.words.slice(0), t;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(t) {
            for (var n = [], r = 0; r < t; r += 4)
              n.push(w());
            return new d.init(n, t);
          }
        }), y = S.enc = {}, A = y.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(t) {
            for (var n = t.words, r = t.sigBytes, s = [], _ = 0; _ < r; _++) {
              var u = n[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
              s.push((u >>> 4).toString(16)), s.push((u & 15).toString(16));
            }
            return s.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(t) {
            for (var n = t.length, r = [], s = 0; s < n; s += 2)
              r[s >>> 3] |= parseInt(t.substr(s, 2), 16) << 24 - s % 8 * 4;
            return new d.init(r, n / 2);
          }
        }, P = y.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(t) {
            for (var n = t.words, r = t.sigBytes, s = [], _ = 0; _ < r; _++) {
              var u = n[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
              s.push(String.fromCharCode(u));
            }
            return s.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(t) {
            for (var n = t.length, r = [], s = 0; s < n; s++)
              r[s >>> 2] |= (t.charCodeAt(s) & 255) << 24 - s % 4 * 8;
            return new d.init(r, n);
          }
        }, e = y.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(t) {
            try {
              return decodeURIComponent(escape(P.stringify(t)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(t) {
            return P.parse(unescape(encodeURIComponent(t)));
          }
        }, a = T.BufferedBlockAlgorithm = v.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new d.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(t) {
            typeof t == "string" && (t = e.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(t) {
            var n, r = this._data, s = r.words, _ = r.sigBytes, u = this.blockSize, p = u * 4, I = _ / p;
            t ? I = o.ceil(I) : I = o.max((I | 0) - this._minBufferSize, 0);
            var N = I * u, O = o.min(N * 4, _);
            if (N) {
              for (var g = 0; g < N; g += u)
                this._doProcessBlock(s, g);
              n = s.splice(0, N), r.sigBytes -= O;
            }
            return new d.init(n, O);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var t = v.clone.call(this);
            return t._data = this._data.clone(), t;
          },
          _minBufferSize: 0
        });
        T.Hasher = a.extend({
          /**
           * Configuration options.
           */
          cfg: v.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(t) {
            this.cfg = this.cfg.extend(t), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            a.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(t) {
            return this._append(t), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(t) {
            t && this._append(t);
            var n = this._doFinalize();
            return n;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(t) {
            return function(n, r) {
              return new t.init(r).finalize(n);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(t) {
            return function(n, r) {
              return new h.HMAC.init(t, r).finalize(n);
            };
          }
        });
        var h = S.algo = {};
        return S;
      }(Math);
      return c;
    });
  }(H)), H.exports;
}
(function(i, f) {
  (function(c, o) {
    i.exports = o(G());
  })(L, function(c) {
    return c.enc.Hex;
  });
})(X);
var q = { exports: {} };
(function(i, f) {
  (function(c, o) {
    i.exports = o(G());
  })(L, function(c) {
    return function(o) {
      var E = c, l = E.lib, w = l.WordArray, R = l.Hasher, S = E.algo, T = [], v = [];
      (function() {
        function A(h) {
          for (var t = o.sqrt(h), n = 2; n <= t; n++)
            if (!(h % n))
              return !1;
          return !0;
        }
        function P(h) {
          return (h - (h | 0)) * 4294967296 | 0;
        }
        for (var e = 2, a = 0; a < 64; )
          A(e) && (a < 8 && (T[a] = P(o.pow(e, 1 / 2))), v[a] = P(o.pow(e, 1 / 3)), a++), e++;
      })();
      var d = [], y = S.SHA256 = R.extend({
        _doReset: function() {
          this._hash = new w.init(T.slice(0));
        },
        _doProcessBlock: function(A, P) {
          for (var e = this._hash.words, a = e[0], h = e[1], t = e[2], n = e[3], r = e[4], s = e[5], _ = e[6], u = e[7], p = 0; p < 64; p++) {
            if (p < 16)
              d[p] = A[P + p] | 0;
            else {
              var I = d[p - 15], N = (I << 25 | I >>> 7) ^ (I << 14 | I >>> 18) ^ I >>> 3, O = d[p - 2], g = (O << 15 | O >>> 17) ^ (O << 13 | O >>> 19) ^ O >>> 10;
              d[p] = N + d[p - 7] + g + d[p - 16];
            }
            var F = r & s ^ ~r & _, M = a & h ^ a & t ^ h & t, W = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22), x = (r << 26 | r >>> 6) ^ (r << 21 | r >>> 11) ^ (r << 7 | r >>> 25), D = u + x + F + v[p] + d[p], K = W + M;
            u = _, _ = s, s = r, r = n + D | 0, n = t, t = h, h = a, a = D + K | 0;
          }
          e[0] = e[0] + a | 0, e[1] = e[1] + h | 0, e[2] = e[2] + t | 0, e[3] = e[3] + n | 0, e[4] = e[4] + r | 0, e[5] = e[5] + s | 0, e[6] = e[6] + _ | 0, e[7] = e[7] + u | 0;
        },
        _doFinalize: function() {
          var A = this._data, P = A.words, e = this._nDataBytes * 8, a = A.sigBytes * 8;
          return P[a >>> 5] |= 128 << 24 - a % 32, P[(a + 64 >>> 9 << 4) + 14] = o.floor(e / 4294967296), P[(a + 64 >>> 9 << 4) + 15] = e, A.sigBytes = P.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var A = R.clone.call(this);
          return A._hash = this._hash.clone(), A;
        }
      });
      E.SHA256 = R._createHelper(y), E.HmacSHA256 = R._createHmacHelper(y);
    }(Math), c.SHA256;
  });
})(q);
const Q = (i, f, c) => c === "subflow" ? "https://subflow.petplate.com" : "https://www.petplate.com", J = (i, f, c, o) => {
  const E = "main";
  return o ? `https://${i}-${c}-${E}-${o}.herokuapp.com` : `https://${i}-${c}-${E}.herokuapp.com`;
}, U = (i, f, c, o, E) => [J(i, f, c, o), E].filter((l) => l).join(":"), b = (i, f, c, o) => [Q(i, f, c), o].filter((E) => E).join(":"), Z = (i) => `https://${i}`, tt = (i, f) => f, nt = (i, f) => {
  var o;
  return `https://admin.shopify.com/store/${(o = i == null ? void 0 : i.split(".")) == null ? void 0 : o[0]}/apps/${f}`;
}, B = "platform", C = "localhost", lt = "production", ut = null, ft = "main", Et = "", pt = process.env.HEROKU_PR_NUMBER, It = null, rt = null, dt = "false", ht = null, et = null, ot = null, st = null, it = null, At = null, ct = null, Pt = null, vt = !1, Ot = null, Tt = null, Rt = null, St = null, yt = null, Nt = null, Lt = null, gt = null, Bt = null, Ct = "QpV30qSdnNeo8HgxwGZMLkLjXshNtQE4sZD3lO4a", wt = null, Ht = null, Ut = null, m = "petplate-2.myshopify.com", Dt = "c37e9fd2530b89aab265cc3bfe5e563a", Yt = "2025-01", Gt = "GTM-M5CCCSM9", bt = "G-3E1NZWRM5Q", mt = "57578c794bbf8da5cc6ff16ac908ceb8", Ft = "https://rdsgb.petplate.com", Mt = !0, Wt = null, xt = "2025-01", Kt = "US", Vt = "EN", Xt = Z(m), kt = null, jt = null, at = null, zt = "gid://shopify/ProductVariant/53368335335733", $t = "gid://shopify/ProductVariant/53368335827253", qt = null, Qt = process.env.NEXT_PUBLIC_SHOW_V9_PRICE_CHANGE, Jt = null, Zt = null, tn = "9e0964421a455ca62fa4fffa48767b35f930635ed143e4b9f3030e3a39b14f57", nn = "javascript-nextjs", rn = "petplate", en = null, on = null, sn = "6Lf8KJopAAAAAHp6VMFsFjOjEy9m0NLsIkG-llH3", cn = "6Lf8KJopAAAAAIW99HnsO7Kz2zMmFU9sV9zpKwRi", an = !1, _n = process.env.SKIP_SUBFLOW_CALCULATING_STEP === "true", ln = U(
  B,
  C,
  "cms",
  process.env.ADMIN_APP_SUFFIX,
  et
), _t = U(
  B,
  C,
  "api",
  process.env.API_APP_SUFFIX,
  rt
), un = U(
  B,
  C,
  "graphql",
  process.env.GRAPHQL_APP_SUFFIX,
  it
), fn = b(B, C, "web", ot), En = b(B, C, "subflow", st), pn = tt(ct, _t), In = nt(m, at);
export {
  et as ADMIN_PORT,
  ln as ADMIN_URL,
  ct as API_NGROK_HOST,
  rt as API_PORT,
  _t as API_URL,
  zt as BUNDLE_PARENT_VARIANT_GID,
  an as DISABLE_CAPTCHA,
  ut as DOMAIN_PREFIX,
  Ft as EDGETAG_EDGE_URL,
  lt as ENV,
  bt as GOOGLE_ANALYTICS_MEASUREMENT_ID,
  cn as GOOGLE_RECAPTCHA_SECRET_KEY,
  it as GRAPHQL_PORT,
  un as GRAPHQL_URL,
  Gt as GTM_CONTAINER_ID,
  It as HEROKU_BRANCH,
  pt as HEROKU_PR_NUMBER,
  Ot as KLAVIYO_API_KEY,
  Wt as KLAVIYO_SITE_ID,
  dt as MAINTENANCE_MODE,
  mt as MIXPANEL_TOKEN,
  At as MONGODB_URI,
  Ut as NEXT_PUBLIC_AISLE_WIDGET_ID,
  ht as NEXT_PUBLIC_CLIENT_WEBHOOK_NAMESPACE,
  sn as NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
  Tt as NEXT_PUBLIC_KLAVIYO_API_KEY,
  Jt as NEXT_PUBLIC_SENTRY_DSN,
  Ht as NEXT_PUBLIC_STOREPOINT_MAP_ID,
  Ct as NEXT_PUBLIC_YOTPO_APP_KEY,
  St as NEXT_PUBLIC_YOTPO_LOYALTY_JS_SDK_ID,
  Rt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_BANNER_WIDGET_ID,
  Nt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_EARNING_POINTS_WIDGET_ID,
  yt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_MY_ACTIVITY_WIDGET_ID,
  Lt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_REDEEM_POINTS_WIDGET_ID,
  gt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_REFER_FRIENDS_WIDGET_ID,
  Bt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_VIP_TIERS_WIDGET_ID,
  wt as NEXT_PUBLIC_YOTPO_REFER_A_FRIEND_PAGE_WIDGET_ID,
  en as SENDGRID_API_KEY,
  on as SENDGRID_DOMAIN,
  tn as SENTRY_AUTH_TOKEN,
  Zt as SENTRY_DSN,
  rn as SENTRY_ORG,
  nn as SENTRY_PROJECT,
  In as SHOPIFY_ADMIN_URL,
  Pt as SHOPIFY_API_KEY,
  Yt as SHOPIFY_API_VERSION,
  jt as SHOPIFY_APP_NAME,
  at as SHOPIFY_APP_NS,
  Kt as SHOPIFY_COUNTRY_ISO_CODE,
  m as SHOPIFY_CUSTOM_DOMAIN,
  vt as SHOPIFY_DEV_SIDENAV,
  Vt as SHOPIFY_LANGUAGE_ISO_CODE,
  Dt as SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  xt as SHOPIFY_STOREFRONT_API_VERSION,
  Xt as SHOPIFY_URL,
  qt as SHOW_PRICE_CHANGE_FEATURE,
  Qt as SHOW_V9_PRICE_CHANGE,
  _n as SKIP_SUBFLOW_CALCULATING_STEP,
  kt as STRIPE_PUBLISHABLE_KEY,
  st as SUBFLOW_PORT,
  En as SUBFLOW_URL,
  $t as SUBSCRIPTION_CARRIER_VARIANT_GID,
  Mt as TRIPLE_WHALE_ENABLED,
  ft as VERCEL_GIT_COMMIT_REF,
  Et as VERCEL_GIT_PULL_REQUEST_ID,
  pn as WEBHOOK_URL,
  ot as WEB_PORT,
  fn as WEB_URL
};
